import { get } from 'lodash';
import { normalizeRiskLevelToStored } from './constants';

/**
 * Maps v2 API keys to v1 keys (what our components expect)
 */
export const API_KEY_MAPPING = {
  // v2 key : v1 key (what components expect)
  name: 'title',
  momentType: 'projectType',
  headline: 'description', //Need to confirm
  tier: 'priority',
  riskLevel: 'riskLevel',
  status: 'status',
  releasePhase: 'releasePhase',
  summary: 'reportingSummary',
  updated: 'lastUpdated',
  inTheWorks: 'tbd',
  featureId: 'featureId',
  releaseId: 'releaseId',
  productId: 'productId',
  mvp: 'mvp',
  demo: 'demo',
  releasePhaseId: 'releasePhaseId'
  //date
  //catergory and others
};

/**
 * Maps an API response object from v2 to v1 format, handling both individual items and collections
 */
export const mapApiResponse = (data: any): Record<string, any> => {
  if (!data || typeof data !== 'object') {
    return {};
  }

  // If it's an array, map each item
  if (Array.isArray(data)) {
    return data.map(item => mapApiResponse(item));
  }

  const result: Record<string, any> = {};

  // Special handling for inTheWorks to tbd conversion (with deep mapping)
  if (data.inTheWorks !== undefined) {
    result.tbd = Array.isArray(data.inTheWorks)
      ? data.inTheWorks.map((item: any) => mapApiResponse(item))
      : [];
    delete data.inTheWorks;
  }

  // Special handling for releaseScheduled (deep mapping of nested structures)
  if (data.releaseScheduled !== undefined) {
    result.releaseScheduled = Array.isArray(data.releaseScheduled)
      ? data.releaseScheduled.map((release: any) => mapApiResponse(release))
      : [];
    delete data.releaseScheduled;
  }

  if (data.releaseEvents !== undefined) {
    result.releaseEvents = Array.isArray(data.releaseEvents)
      ? data.releaseEvents.map((release: any) => mapApiResponse(release))
      : [];
    delete data.releaseEvents;
  }

  // Map known fields at the current level
  Object.entries(API_KEY_MAPPING).forEach(([v2Key, v1Key]) => {
    if (data[v2Key] !== undefined) {
      result[v1Key] =
        v1Key === 'riskLevel'
          ? normalizeRiskLevelToStored(data[v2Key]) ?? data[v2Key]
          : data[v2Key];
      // Remove the original key to avoid double processing
      delete data[v2Key];
    }
  });

  // Handle remaining fields
  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // Recursively map arrays of objects; leave primitives unchanged
      result[key] = value.map(item => {
        if (item && typeof item === 'object' && !Array.isArray(item)) {
          return mapApiResponse(item);
        }
        return item;
      });
    } else if (typeof value === 'object' && value !== null) {
      result[key] = mapApiResponse(value);
    } else if (key === 'riskLevel' && typeof value === 'string') {
      result[key] = normalizeRiskLevelToStored(value) ?? value;
    } else {
      result[key] = value;
    }
  });

  return result;
};
